import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UtilService } from '../../shared/util/util.service';
import {
  DateValueAccessor,
  CreateDateValueAccessorProvider,
  CreateDateValueValidationProvider,
} from '../../shared/widgets/value-accessors/date-value-accessor';

@Component({
  standalone: false,
  selector: 'wl-date-selector',
  templateUrl: 'date-selector.component.html',
  providers: [CreateDateValueAccessorProvider(DateSelectorComponent), CreateDateValueValidationProvider(DateSelectorComponent)],
})
export class DateSelectorComponent extends DateValueAccessor implements OnInit {
  @Input() required: any;
  @Input() disabled: boolean = false;
  @Input() minDate: Date = null;
  @Input() showButtonBar: boolean = false;
  @Input() inputStyle: any;
  @Input() placeholder: string = '';
  @Input() showClear: boolean = false;
  @Input() styleClass: string = '';
  @Input() showIcon: boolean = true;
  @Output() public onDateChanged = new EventEmitter<Date>();

  public _utilService: UtilService;
  public _lastValue: Date;
  // PrimeNG compares the full timestamp against minDate and blanks the input when the value is earlier,
  // so a same-day value with an earlier time would disappear. This selector is date-only, so compare by day.
  public minDateStartOfDay: Date = null;

  public dateAsString: string;
  public yearRange: string = new Date().getFullYear() - 3 + ':' + (new Date().getFullYear() + 3);

  public constructor(utilService: UtilService) {
    super();
    this._utilService = utilService;
    this.value = new Date();
  }

  ngOnInit() {}

  modelChange(selectedValue: Date) {
    this.emitOutputObject();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.minDate) {
      this.minDateStartOfDay = this.minDate ? new Date(new Date(this.minDate).setHours(0, 0, 0, 0)) : null;
    }
    this.emitOutputObject();
  }

  dateSelected(selectedValue: Date) {
    this.value = selectedValue;
    this.emitOutputObject();
  }

  emitOutputObject = (): void => {
    this.onDateChanged.emit(this.value);
  };
}
